import { Select, Space, DatePicker } from "antd";
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
const { RangePicker } = DatePicker;

export type DateFilterType = 'weekly' | 'monthly' | 'yearly' | 'custom';

interface DateFilterSelectProps {
  value: DateFilterType;
  onChange: (value: DateFilterType, dates?: { from: string; to: string }) => void;
}

export const DateFilterSelect: React.FC<DateFilterSelectProps> = ({ 
  value, 
  onChange 
}) => {
  const handleDateRangeChange = (dates: [Dayjs | null, Dayjs | null] | null) => {
    if (dates && dates[0] && dates[1]) {
      onChange('custom', {
        from: dates[0].startOf('day').toISOString(),
        to: dates[1].endOf('day').toISOString()
      });
    }
  };

  const handleFilterChange = (newValue: DateFilterType) => {
    const now = dayjs();
    let from: Dayjs;
    let to: Dayjs = now;

    switch (newValue) {
      case 'weekly':
        from = now.subtract(1, 'week');
        break;
      case 'monthly':
        from = now.subtract(1, 'month');
        break;
      case 'yearly':
        from = now.subtract(1, 'year');
        break;
      default:
        onChange(newValue);
        return;
    }

    onChange(newValue, {
      from: from.startOf('day').toISOString(),
      to: to.endOf('day').toISOString()
    });
  };

  return (
    <Space>
      <Select
        value={value}
        onChange={handleFilterChange}
        style={{ width: 120 }}
        options={[
          { value: 'weekly', label: 'Weekly' },
          { value: 'monthly', label: 'Monthly' },
          { value: 'yearly', label: 'Yearly' },
          { value: 'custom', label: 'Custom' },
        ]}
      />
      {value === 'custom' && (
        <RangePicker onChange={handleDateRangeChange} />
      )}
    </Space>
  );
}; 